import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { useAllCommunities } from "pages/store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { getCurrentUserRole } from "modules/utilities/utility";

function AddCommunity() {
  const [modalShow, setModalShow] = useState(false);
  const [inputChange, setInputChange] = useState("");
  const { postAddCommunity } = useAllCommunities();
  const { setToaster } = useToast();

  const handleSubmit = (event) => {
    event.preventDefault();
    postAddCommunity(
      {
        tag_name: inputChange,
        tag_slug: inputChange,
      },
      setToaster
    );
    setTimeout(()=>{
        setModalShow(false);
    },1000)
  };

  const handleChange = (event) => {
    setInputChange(event.target.value);
  };

  return (
    <div>
      <Button variant="primary" className={getCurrentUserRole()==='support'?"disabled":null} onClick={() => setModalShow(true)}>
        Add Community
      </Button>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Community
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="inputData">
                Enter English text, numbers, or dates:
              </label>
              <input
                type="text"
                className="form-control"
                id="inputData"
                pattern="[a-zA-Z0-9\s]+"
                title="Only English text, numbers, and dates are allowed (no special characters)."
                onChange={handleChange}
                required
              />
              <div className="invalid-feedback">
                Only English text, numbers, and dates are allowed (no special
                characters).
              </div>
            </div>
            <button
              type="submit"
              className="btn btn-primary mt-3 float-end mb-4"
            >
              Add Community
            </button>
          </form>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
}

export default AddCommunity;
